<ion-header>
  <ion-toolbar color="noir">
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon color="light" name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="image-viewer">
  <div class="image-wrapper">
    <div class="image">
      <swiper-container #swiper zoom="true" (afterinit)="swiperReady()">
        <swiper-slide>
          <div class="swiper-zoom-container">
            <img [src]="'data:image/jpeg;base64,' + picture?.contenu | safeUrl" />
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</div>
